import GigCard from './GigCard';

export default GigCard;
